import { textBlack, textGrey, webFont } from '../../config/theme';

const style = {
	subHeader: {
		color: textBlack,
		fontWeight: 500,
		fontSize: '16px',
		fontFamily: webFont
	},
	listItem: {
		color: textGrey,
		fontWeight: 300,
		textDecoration: 'none',
		fontSize: '16px',
		fontFamily: webFont
	},
	setFont: {
		fontFamily: webFont,
		fontWeight: 500
	},
	storeImage: {
		maxHeight: '55px',
		margin: '10px'
	},
	storeImageMob: {
		maxHeight: '60px'
	},
	mobileStore: {
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center'
	},
	logo: {
		maxHeight: '60px'
	},
	footerNote: {
		color: textGrey,
		fontWeight: 400,
		textDecoration: 'none',
		fontSize: '12px',
		fontFamily: webFont,
		textAlign: 'right',
	},
	footerNoteMobile: {
		color: textGrey,
		fontWeight: 400,
		textDecoration: 'none',
		fontSize: '12px',
		fontFamily: webFont,
		textAlign: 'center',
		marginTop: 15,
	},
	downloadApp: {
		marginLeft: '10px'
	}
};

export default style;
